import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, LinearProgress, Stack } from "@mui/material";

//共通コンポーネント
import { Header } from "../../components";
import { ERROR, CUSTOMER_RESULT } from "../../routes/path";
//決済処理API
import { setMedicalAccounting } from "../../server/axios";
import { getGmoMessageByErroRCode } from "../../utils/getGmoMsgUtil";

/**
 * 決済処理中画面
 * @returns
 */
const PayingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (!location.state) navigate(ERROR);
    if (process.env.NODE_ENV === "development" && firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }

    if (location.state.useHistryCard) {
      setMedicalAccounting({
        custmerId: location.state.custmerId,
        useHistryCard: true,
        selectedCardSeq: location.state.selectedCardSeq,
        receiptedNumber: location.state.receiptedNumber,
        paymentMethodClass: location.state.paymentMethodClass,
        updateDatetime: location.state.updateDatetime,
      }).then((res) => {
        handleResponse(res);
      });
    } else {
      if (!location.state.paymentMethodClass || !location.state.gmoToken) {
        throw new Error("パラメータ不正");
      }
      handlePayment();
    }
  }, []);

  const handlePayment = () => {
    setMedicalAccounting({
      custmerId: location.state.custmerId,
      useHistryCard: false,
      receiptedNumber: location.state.receiptedNumber,
      paymentMethodClass: location.state.paymentMethodClass,
      gmoToken: location.state.gmoToken,
      updateDatetime: location.state.updateDatetime,
    }).then((res) => {
      handleResponse(res);
    });
  };

  const handleResponse = (res) => {
    let errMsg = "";
    let errorCode = "E99";
    switch (res.data.result) {
      case -2: // -2 システム定数エラー
      case -4: // -4 オーダーID桁数不正,取引登録/決済実行エラー
        const response = res.data.message;
        const regex = /ErrInfo=([^|&]*)/;
        const match = response.match(regex);
        errorCode = match ? match[1] : "E99";
        errMsg = getGmoMessageByErroRCode(errorCode);
        navigate(CUSTOMER_RESULT, {
          state: {
            header: "決済エラー",
            message: `${errorCode}：\n${errMsg}`,
          },
        });
        break;
      case -1: // -1 排他エラー
        navigate(CUSTOMER_RESULT, {
          state: {
            header: "決済エラー",
            message: "決済に失敗しました。もう一度お試しください。",
          },
        });
        break;
      case -3: // -3 処方箋取消済
        navigate(CUSTOMER_RESULT, {
          state: {
            header: "お会計",
            message: "選択されたお申し込みは、取消されています。",
          },
        });
        break;
      case -5: // -5 決済完了後エラー
        navigate(CUSTOMER_RESULT, {
          state: {
            header: "決済エラー",
            message: `決済は完了しましたが、データ登録に失敗しました。\nお手数ですが、コールセンターへお問い合わせください。`,
          },
        });
        break;
      case 1: // 1 決済成功
        navigate(CUSTOMER_RESULT, {
          state: {
            header: "決済完了",
            message: "決済が完了しました。",
          },
        });
        break;
      default: // このルートは使っていない
        errMsg = getGmoMessageByErroRCode(errorCode);
        navigate(CUSTOMER_RESULT, {
          state: {
            header: `決済エラー`,
            message: `${errorCode}：\n${errMsg}`,
          },
        });
        break;
    }
  };

  return (
    <>
      <Header title="決済処理中" />
      <Stack
        height="76vh"
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
        spacing={2}
      >
        <Typography sx={{ fontSize: "110%" }} align="left">
          しばらくお待ちください。
        </Typography>
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      </Stack>
    </>
  );
};

export default PayingPage;
